const KEY = 'plato-console-invite';
let pending: string | null = null;

export function rememberInviteFromUrl(): void {
  const match = /^#\/invite\/([A-Za-z0-9_-]{20,200})$/.exec(window.location.hash);
  if (match?.[1] === undefined) return;
  try {
    window.sessionStorage.setItem(KEY, match[1]);
  } catch {
    pending = match[1];
  }
  window.history.replaceState(null, '', '#/');
}

export function peekInvite(): string | null {
  try {
    return window.sessionStorage.getItem(KEY) ?? pending;
  } catch {
    return pending;
  }
}

export function forgetInvite(): void {
  pending = null;
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {}
}
